<template>
  <div>
    <app-panel title="Временный импорт состояния счетчиков" flex
               class="house-importer-finish-stage-import-device-panel">
      <div class="import-source-stage__panel-content">
        <div class="import-source-stage__panel-file import-source-stage__panel-col">
          <div class="import-source-stage__no-file-error" v-if="counterFileError">
            Выберите файл
          </div>

          <vs-upload
                  action="#"
                  :limit="1"
                  :show-upload-button="false"
                  text="Добавить файл"
                  @change="onCounterReportFileChange"
                  @on-delete="onCounterReportFileDelete"
                  class="import-source-stage__uploader import-source-stage__uploader_single"
                  ref="counterUploader"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div class="import-source-stage__panel-settings import-source-stage__panel-col">
          <div class="import-source-stage__panel-settings-row">
            <app-input label="Номер столбца с которого начинается первый блок с информацией о приборах"
                       vtype="uint"
                       v-model="counterReportBody.first_block"
                       :danger.sync="counterReportErrors.first_block"
                       danger-text="Заполните номер столбца"
            />
          </div>

          <div class="import-source-stage__panel-settings-row">
            <app-input label="Длина блока с информацией об одном приборе"
                       vtype="uint"
                       v-model="counterReportBody.block_length"
                       :danger.sync="counterReportErrors.block_length"
                       danger-text="Заполните номер столбца"
            />
          </div>

          <div class="import-source-stage__panel-settings-row">
            <app-input label="Номер первой строки с информацией о приборах"
                       vtype="uint"
                       v-model="counterReportBody.data_start_row"
                       :danger.sync="counterReportErrors.data_start_row"
                       danger-text="Заполните номер столбца"
            />
          </div>

          <div class="import-source-stage__panel-settings-row">
            <app-input label="Номер строки с названиями типов приборов"
                       vtype="uint"
                       v-model="counterReportBody.device_type_row"
                       :danger.sync="counterReportErrors.device_type_row"
                       danger-text="Заполните номер столбца"
            />
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 15px">
        <app-button color="success" @click="importFile">Импортировать</app-button>
      </div>

      <div class="house-importer-finish-stage-import-device-panel__status-wrapper" v-if="status !== STATUSES.default">
        <div class="house-importer-finish-stage-import-device-panel__loading" v-if="status === STATUSES.importing">
          <div class="block-loading"/>
          <div>Импортирую файл...</div>
        </div>
        <div class="house-importer-finish-stage-import-device-panel__imported" v-if="status === STATUSES.imported">
          <div class="house-importer-finish-stage-import-device-panel__imported-icon">
            <app-icon name="CheckIcon" size="120px"/>
          </div>
          <div class="house-importer-finish-stage-import-device-panel__imported-text">
            Файл импортирован
          </div>
        </div>
        <div class="house-importer-finish-stage-import-device-panel__error" v-if="status === STATUSES.error">
          <div class="house-importer-finish-stage-import-device-panel__error-icon">
            <app-icon name="XIcon" size="80px"/>
          </div>
          <div class="house-importer-finish-stage-import-device-panel__error-text">
            Файл не импортирован

            <div class="house-importer-finish-stage-import-device-panel__error-sub-text">
              {{errorText}}
            </div>
          </div>
        </div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  let STATUSES = {
    default: 0,
    importing: 1,
    imported: 2,
    error: 3
  };


  export default {
    name: "ImportDevicesPanel",
    props: {
      importInfo: {}
    },
    data() {
      return {
        STATUSES: STATUSES,
        status: STATUSES.default,
        counterReportFile: null,
        counterReportBody: {
          first_block: null,
          block_length: null,
          data_start_row: null,
          device_type_row: null
        },
        counterReportErrors: {
          first_block: false,
          block_length: false,
          data_start_row: false,
          device_type_row: false
        },
        counterFileError: false,
        errorText: ""
      }
    },
    computed: {
      counterReportErrorsHasErrors() {
        return !!Object.values(this.counterReportErrors).filter(v => v).length;
      },
    },
    methods: {
      checkCounterReportBody() {
        if (this.counterReportFile === null) {
          this.counterFileError = true;
        }

        if (this.counterReportBody.first_block === null) {
          this.counterReportErrors.first_block = true;
        }

        if (this.counterReportBody.block_length === null) {
          this.counterReportErrors.block_length = true;
        }

        if (this.counterReportBody.data_start_row === null) {
          this.counterReportErrors.data_start_row = true;
        }

        if (this.counterReportBody.device_type_row === null) {
          this.counterReportErrors.device_type_row = true;
        }
      },
      resetCounterReportBody() {
        Object.assign(this.mainReportBody, {
          first_block: null,
          block_length: null,
          data_start_row: null,
          device_type_row: null
        });
        this.resetCounterFile();
      },
      resetCounterReportErrors() {
        Object.assign(this.mainReportErrors, {
          first_block: false,
          block_length: false,
          data_start_row: false,
          device_type_row: false
        });
        this.counterFileError = false;
      },
      resetCounterFile() {
        this.counterReportFile = null;
        this.$refs.counterUploader.srcs = [];
        this.$refs.counterUploader.itemRemove = [];
        this.$refs.counterUploader.filesx = [];
      },
      onCounterReportFileChange(value, files) {
        this.counterReportFile = files.filter(file => !file.remove)[0] || null;
        this.counterFileError = false;
      },
      onCounterReportFileDelete() {
        this.counterReportFile = null;
        this.counterFileError = false;
      },
      async importFile() {
        this.checkCounterReportBody();

        if (this.counterReportErrorsHasErrors) {
          return false;
        }

        try {
          this.status = STATUSES.importing;

          let body = Object.assign({
            counters_report: this.counterReportFile,
            import_id: this.importInfo.id
          }, this.counterReportBody);

          let bodyFormData = new FormData();

          for (let key in body) {
            if (body.hasOwnProperty(key)) {
              if (Array.isArray(body[key])) {
                for (let i = 0; i < body[key].length; i++) {
                  bodyFormData.append(`${key}[${i}]`, body[key][i]);
                }
              } else {
                bodyFormData.append(key, body[key])
              }
            }
          }

          await this.$http.post('import/houses/temp_devices_state', bodyFormData, {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          });
          setTimeout(() => {
            this.status = STATUSES.imported;
          }, 300);
        } catch (e) {
          if (e.response) {
            this.errorText = "Ошибка сервера - " + e.response.status;
          } else {
            this.errorText = "Неизвестная ошибка";
          }
          this.status = STATUSES.error;
        }
      }
    }
  }
</script>

<style lang="scss">
  .import-source-stage {
    display: flex;
    flex-wrap: wrap;
    margin: -7.5px;

    &__send-button {
      position: fixed;
      right: 15px;
      bottom: 15px;
    }

    &__col {
      flex: 1 1 50%;
      max-width: 50%;
      padding: 7.5px;

      & > .app-panel {
        height: 100%;

        .app-panel__body {
          height: calc(100% - 71px);
        }
      }

      &_b {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }

    &__no-file-error {
      text-align: center;
      font-size: 11px;
      text-transform: uppercase;
      color: rgba(var(--app-danger), 1);
      font-weight: 600;
    }

    &__panel-content {
      display: flex;
      /*align-items: center;*/
      margin: 0 -7.5px;
      height: 100%;
    }

    &__panel-col {
      padding: 0 7.5px;
    }

    &__panel-file {
      border-right: 1px solid rgba(0, 0, 0, .2);

      flex-shrink: 0;
      flex-basis: 40%;
      display: flex;
      flex-direction: column;
    }

    &__panel-settings {
      flex: 1;

      &-row {
        margin-bottom: 15px;
      }
    }

    &__uploader {
      &_single {
        width: 100%;
        height: 100%;

        .con-img-upload {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .img-upload {
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive span {
              font-size: 16px;
              word-break: break-all;
            }
          }
        }
      }

      &_charges {
        .con-img-upload {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;

          .img-upload {

            margin: 5px;
            width: 100px;
            height: 100px;
            border-radius: 10px;
            box-shadow: 0 4px 20px 1px rgba(0, 0, 0, .06), 0 1px 4px rgba(0, 0, 0, .08);
            border: 1px solid rgba(0, 0, 0, .2);

            .text-archive {
              i {
                font-size: 5rem;
              }

              span {
                font-size: 12px;
                word-break: break-all;
              }
            }
          }
        }

        .con-input-upload {
          width: 100px;
          height: 100px;
          margin: 5px;

          .text-input {
            font-size: 12px;
            min-width: 100px;
            line-height: 1.1;
          }
        }
      }
    }

  }

  .house-importer-import-source-stage-multiple-charges {
    display: flex;

    .app-input__label {
      margin-bottom: 0;
      margin-right: 10px;
    }
  }

  .import-source-stage-post-sending {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading {
      width: 100px;
      height: 100px;
      flex: 0;
      margin-bottom: 15px;
    }
  }

  .house-importer-finish-stage-import-device-panel {
    .app-panel__body {
      position: relative;
    }

    &__status-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 99999;
      background: #fff;
    }

    &__loading {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;

      .block-loading {
        width: 60px;
        height: 60px;
        flex: 0;
        margin-bottom: 15px;
      }
    }

    &__imported {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-success), 1);
      height: 100%;

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon {
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }

    &__error {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: rgba(var(--app-danger), 1);
      height: 100%;

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      &-sub-text {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 1.1;

        &-icon {
          margin-left: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: -2px;
        }

      }
    }
  }

</style>